import { FC } from "react";
import { AssignmentType, TaskAssignmentPayload } from "tm-shared/types";

import { GalleryUploader } from "@/domains/media";
import { Viewfinder } from "@/domains/media";
import { PhotoCaptions } from "@/types/common";

import { StyledBlock, StyledTextArea } from "../../Styled";

interface PhotoTextProps {
    pointId: string;
    title: string;
    payload?: TaskAssignmentPayload;
    onChangeComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onUploadPhoto: (photo: string) => void;
    onDeletePhoto: (photoId: string) => void;

    captions: PhotoCaptions;
    assignmentType: AssignmentType;
}

export const PhotoText: FC<PhotoTextProps> = ({
    pointId,
    title,
    payload,
    onChangeComment,
    onUploadPhoto,
    onDeletePhoto,
    captions,
    assignmentType,
}) => {
    const cameraProps =
        assignmentType === AssignmentType.PricesDistribution
            ? { viewfinder: Viewfinder }
            : undefined;

    return (
        <StyledBlock>
            <StyledTextArea
                placeholder="Введіть коментар"
                rows={6}
                value={payload?.comment ?? ""}
                onChange={onChangeComment}
            />

            <GalleryUploader
                previewTitle={title}
                onUpload={onUploadPhoto}
                onDelete={onDeletePhoto}
                pointId={pointId}
                savedPhotos={payload?.photos ?? []}
                captionLines={captions}
                cameraProps={cameraProps}
            />
        </StyledBlock>
    );
};
